import { render, staticRenderFns } from "./ComeFunziona.vue?vue&type=template&id=198ed7bc&scoped=true&"
import script from "./ComeFunziona.vue?vue&type=script&lang=js&"
export * from "./ComeFunziona.vue?vue&type=script&lang=js&"
import style0 from "./ComeFunziona.vue?vue&type=style&index=0&id=198ed7bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198ed7bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('198ed7bc')) {
      api.createRecord('198ed7bc', component.options)
    } else {
      api.reload('198ed7bc', component.options)
    }
    module.hot.accept("./ComeFunziona.vue?vue&type=template&id=198ed7bc&scoped=true&", function () {
      api.rerender('198ed7bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ComeFunziona.vue"
export default component.exports